
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClarityModule } from '@clr/angular';

import { HybridInterconnectEmbed } from './hybrid-interconnect-embed';
import { AuthTokenInterceptor } from 'app/interceptors/auth-token-interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
    declarations: [
        HybridInterconnectEmbed
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule,
        ClarityModule.forRoot(),
        HttpClientModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true
        }
    ],
    exports: [
        HybridInterconnectEmbed
    ]
})

export class HybridInterconnectModule {
    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/components/hybrid-interconnect/hybrid-interconnect.module.ts